// extracted by mini-css-extract-plugin
export default {"root":"styles_root__Bc0zS","title":"styles_title__nLZ-h","infoLink":"styles_infoLink__1vVYp"};